module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    attrs: {
      "id": "rloi"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0008#loi"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    attrs: {
      "id": "racknow"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0009#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rch01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0010#ch01"
    }
  }, [_vm._v("Carrie On: An Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Linda Mizejewski and Tanya D. Zuk")]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0011#pt01"
    }
  }, [_vm._v("I. Leia/Carrie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0012#ch02"
    }
  }, [_vm._v("Who Owns Carrie Fisher? A Complicated Embodiment of Manufactured Commodity and Avatar of Resistance")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Jennifer M. Fogel")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0013#ch03"
    }
  }, [_vm._v("Gatekeeping the Past: Fandom and the Gendered Cultural Memory of "), _c('i', [_vm._v("Star Wars")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Philipp Dominik Keidl")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0014#ch04"
    }
  }, [_vm._v("Harvesting the Celebrity Interface: Carrie Fisher, Virtual Performance, and Software Stars")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Andrew Kemp-Wilcox")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0015#ch05"
    }
  }, [_vm._v("“Carrie Fisher Sent Me”: Gendered Political Protest, "), _c('i', [_vm._v("Star Wars")]), _vm._v(", and the Women’s March")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Tanya D. Zuk")]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0016#pt02"
    }
  }, [_vm._v("II. Carrie/Leia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0017#ch06"
    }
  }, [_vm._v("Comedy from the Edge: Carrie Fisher’s Autobiographical Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Linda Mizejewski")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0018#ch07"
    }
  }, [_vm._v("Postcards from the Valley of the Broads: Carrie Fisher, Jacqueline Susann, and Feminist Camp Authorship")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Ken Feil")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch08"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "viii",
      "id": "pviii",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0019#ch08"
    }
  }, [_vm._v("“My body hasn’t aged as well as I have. Blow us”: Carrie Fisher and the Unruly Aging Actress")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Kristen Anderson Wagner")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0020#ch09"
    }
  }, [_vm._v("“Stay afraid, but do it anyway”: Carrie Fisher’s Mental Health Advocacy")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Cynthia A. Hoffner and Sejung Park")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0021#ch10"
    }
  }, [_vm._v("Threshold Guardian to Space Mom: Here, but for the Sake of Carrie, Go I")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Slade Kinnecott")]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf",
    attrs: {
      "id": "rch11"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0022#ch11"
    }
  }, [_vm._v("Appendix 1. What Would Carrie Fisher Do?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Lindsay van Ekelenburg")]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rch12"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0023#ch12"
    }
  }, [_vm._v("Appendix 2. Carrie Fisher Media Work, Appearances, and Fanworks")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Maghan Jackson")]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf",
    attrs: {
      "id": "rwrk_ctd"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0024#wrk_ctd"
    }
  }, [_vm._v("Works Cited")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rcontrib"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0025#contrib"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rindex"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0026#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5905a467","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-midejewski-0007.vue
// module id = 72
// module chunks = 0